import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'

import Notification from 'components/Notification'
import SessionOutDialog from 'components/SessionOutDialog'
import TopNav from 'partials/TopNav'
import Footer from 'partials/Footer'

import { adminInit, fetchGrades } from './actions'

class Admin extends Component {

  componentDidMount() {
    this.props.dispatch(adminInit())
    this.props.dispatch(fetchGrades())
  }

  render() {
    const { __name, __session, location, children } = this.props

    return (
      <div>
        <TopNav
          name={__name}
          session={__session}
          currentPath={location.pathname}
        />
        <div className="container">
          {children}
          <Footer
            color={__session.get('campus_color')}
            campus={__session.get('campus')}
          />
        </div>
        <Notification />
        <SessionOutDialog />
      </div>
    )
  }
}

Admin.propTypes = {
  __name: PropTypes.string,
  __session: PropTypes.object,
  location: PropTypes.object,
  children: PropTypes.node,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __name: state.auth.getIn(['me', 'name']),
    __session: state.auth.get('session'),
  }
}

export default connect(mapStateToProps)(Admin)



// WEBPACK FOOTER //
// ./src/containers/Admin/index.js